exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pointer[data-v-ba643018]{cursor:pointer}.note[data-v-ba643018]{font-size:14px;color:grey}.uppercase[data-v-ba643018]{text-transform:uppercase}.upgrade[data-v-ba643018]{font-size:12px;color:gold;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ba643018","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NavMenu.vue
// module id = Awb7
// module chunks = 0